import { useCoreDoc } from "./useCoreDoc";
import { useSettings } from "./settings";

/** *No badges* (Settings → How it feels): counts are left out everywhere, as its hint says — the habit summary,
 * "n set" on the panel's groups, the waiting changes of a bin, the tray. */
export function useMuteBadges(): boolean {
  const { handle } = useCoreDoc();
  return useSettings(handle).a11y.muteBadges;
}
